export default {"src":"/_next/static/media/icone-quark.ea860773.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};